<template>
  <content-container>
    <section>
      <b-container>
        <b-row>
          <!-- Иконка ========================== -->
          <b-col cols="auto" class="icon">
            <b-skeleton-wrapper :loading="loading">
              <template #loading>
                <div class="unknown-icon center-both border rounded">
                  <div>
                    <b-skeleton type="avatar"></b-skeleton>
                  </div>
                </div>
              </template>

              <div
                v-if="item"
                v-bind:class="{
                  'user-icon': item.is_individual,
                  'org-icon': !item.is_individual,
                }"
              ></div>
              <div v-else class="unknown-icon"></div>
            </b-skeleton-wrapper>
          </b-col>
          <!-- Детали ========================= -->
          <b-col class="mb-5 mb-lg-2">
            <div class="client v-center mb-4">
              <b-skeleton-wrapper :loading="loading">
                <template #loading>
                  <div>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="25%"></b-skeleton>
                    <b-skeleton width="35%"></b-skeleton>
                  </div>
                </template>

                <template v-if="item">
                  <template v-if="item.is_individual">
                    <div class="type">An individual:</div>
                    <h2>
                      {{ item.user.first_name }} {{ item.user.last_name }}
                    </h2>
                  </template>
                  <template v-else>
                    <div class="type">Company / Organization:</div>
                    <h2>{{ item.company }}</h2>
                    <h3 class="dba" v-if="item.dba">{{ item.dba }}</h3>
                  </template>
                </template>
              </b-skeleton-wrapper>
            </div>
            <div class="address">
              <template v-if="item">
                <div v-if="item && item.address">{{ item.address }}</div>
                <div v-if="item && item.address2">{{ item.address2 }}</div>
                <div>
                  <span class="city">{{ item.city }}</span
                  >, <span class="region">{{ item.region }}</span>
                </div>
                <div class="zip">{{ item.postal_code }}</div>
                <country :iso="item.country"></country>
              </template>
            </div>

            <!--
        <div>Страны: {{ $store.state.countriesLoading }}</div>
        <div>{{ this.item }}</div>
    -->
          </b-col>
          <!-- Действия ========================= -->
          <b-col cols="12" lg="2" class="q-actions">
            <b-form-group label="Quick Actions" label-class="font-weight-bold">
              <div class="actions">
                <div class="action">
                  <div class="label">
                    <div class="title">Suspend</div>
                    <div class="desc">
                      Suspend entire client account with all users.
                    </div>
                  </div>
                  <div class="ctrl">
                    <b-form-checkbox
                      v-model="isSuspended"
                      :disabled="suspending"
                      switch
                      size="lg"
                    ></b-form-checkbox>
                  </div>
                </div>
                <div class="action">
                  <div class="label">
                    <div class="title">Delete</div>
                    <div class="desc">
                      Delete entire client account with all users.
                    </div>
                  </div>
                  <div class="ctrl">
                    <b-button variant="danger" v-b-modal.delete-client
                      >Delete</b-button
                    >
                  </div>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <b-modal
        id="delete-client"
        centered
        title="Удаление Клиента"
        body-class="client-delete-body"
        footer-bg-variant="light"
        @ok="handleClientDelete"
        @shown="handleModalShown"
        :busy="deleting"
        ref="delete-client"
      >
        <p class="my-4">Ты уверен?</p>
      </b-modal>
    </section>
    <section>
      <b-card class="text-center">
        <div class="">
          Что то еще про клиента? Может баланс, нагрузка и тд...
        </div>
      </b-card>
    </section>
  </content-container>
</template>

<script>
import Country from "@/components/Country.vue";
import ContentContainer from "../ContentContainer.vue";
import {
  URL_LOAD_CLIENT,
  URL_DELETE_CLIENT,
  URL_SUSPEND_CLIENT,
} from "@/globals";

export default {
  components: { Country, ContentContainer },
  name: "ClientDetails",
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      suspending: false,
      deleting: false,
      item: null,
    };
  },
  methods: {
    load(client_id) {
      if (!client_id) return;
      let promise = this.$get(URL_LOAD_CLIENT.format(client_id));
      return promise
        .then((result) => {
          this.item = result;
          console.log("result: ", result);
        })
        .catch(() => {
          return [];
        });
    },
    handleClientDelete(e) {
      e.preventDefault();
      console.log("deleteClient: ", e);
      let promise = this.$http_delete(
        URL_DELETE_CLIENT.format(this.item.id),
        {},
        true,
        "deleting"
      );
      return promise
        .then(() => {
          this.$router.go(-1);
          this.$bvModal.hide("delete-client");
        })
        .catch((e) => {
          this.$bvModal.hide("delete-client");
          this.$alert.show(e);
        });
    },
    handleModalShown() {
      this.$alert.hide();
    },
  },
  computed: {
    // a computed getter
    isSuspended: {
      get: function () {
        let r = this.item && this.item.suspended;
        return r;
      },
      set: function (checked) {
        if (checked == this.isSuspended) return;
        console.log("onSuspend: ", checked);
        let promise = this.$patch(
          URL_SUSPEND_CLIENT.format(this.item.id),
          { value: checked },
          true,
          "suspending"
        );
        return promise
          .then((result) => {
            this.item.suspended = result.suspended;
            console.log("result: ", result);
          })
          .catch((e) => {
            this.$alert.show(e);
          });
      },
    },
  },
  mounted() {
    let params = this.$route.params;
    if (!params.item) {
      this.load(params.id);
    } else {
      this.item = params.item;
    }
  },
};
</script>

<style scoped>
.icon {
  padding: 0;
}
.org-icon {
  height: 100px;
  width: 100px;
  content: "";
  display: inline-block;
  background-image: url(/organization_icon.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 18px;
}
.user-icon {
  height: 100px;
  width: 100px;
  content: "";
  display: inline-block;
  background-image: url(/user_icon.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 18px;
}
.unknown-icon {
  height: 100px;
  width: 100px;
  content: "";
  margin-right: 18px;
}
.client {
  min-height: 100px;
  margin-bottom: 3em;
}
.client .type {
  font-size: 80%;
  color: var(--secondary);
  padding-bottom: 0.25em;
}
.client h2 {
  line-height: 1em;
}
.client h3 {
  font-size: 110%;
}
.q-actions {
  min-width: 300px;
}
.action {
  display: flex;
  padding: 1em 0;
}
.action:not(:last-child) {
  border-bottom: 1px solid #ccc;
}
.action .label {
  flex-grow: 4;
}
.action .title {
  flex-grow: 4;
  font-size: 90%;
  padding-bottom: 0.5em;
}
.action .desc {
  font-size: 80%;
  color: var(--secondary);
}
.action .ctrl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1.5em;
}
</style>